import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
/**
 * Combina classes Tailwind resolvendo conflitos (ex.: `bg-ax-obsidian bg-ax-graphite`
 * mantém apenas a última). Padrão de toda UI AXIOMA.
 */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
//# sourceMappingURL=cn.js.map